import React from "react";
import { IconBox, PriceBox, NameBox } from "../../../../components/molecules";
import IconBoxII from '../../../../components/molecules/IconBoxII/IconBoxII';
import { Title } from '../../../../components/atoms'
import viewIcon from "../../../../assets/images/view-icon.svg";
import printIconDark from "../../../../assets/images/print-icon-dark.svg";
import printIconLight from "../../../../assets/images/print-icon.svg";
import {ReactComponent as RequestFedExIcon} from "../../../../assets/images/request-FedEx-icon.svg";
import serviceIcon from '../../../../assets/images/serviceIcon.png';
import productIcon from '../../../../assets/images/productIcon.png';
import tracIcon from "../../../../assets/images/track-icon.png";
import memorabiliaIcon from '../../../../assets/images/memorabilia-icon.svg'

export const OrdersInProgressRow = ({
  customerName,
  orderValue,
  orderDate,
  orderRef,
  viewOnClick,
  onReadyForShipment,
  printOnClick,
  shippingLabel,
  isService,
  isMemorabilia,
  merchantRecievedService,
  ordetTrackingID,
  orderReturnTrachingId
}) => {
  
  return (
    <div className="order-row d-flex gap-3 w-100 justify-content-between">
      {/* <div>
            <IconBoxII icon={isService? serviceIcon : productIcon} title="" tooltip={isService ? "Service Order" : "Physical Product Order"}  />
      </div> */}
      <div  className="d-flex flex-column flex-sm-row gap-5">
        <div className="gap-4" style={{alignItems:'center', justifyContent:'center', display:'flex', flexDirection:'row', flexWrap:'wrap' }}>
          <img src={isService ? serviceIcon: isMemorabilia ? memorabiliaIcon : productIcon} style={{width:isService ?'18px' : isMemorabilia ? '26px' : '24px', height:isService ?'18px' : isMemorabilia ? '26px' : '24px', display:'flex', marginLeft:'3px'}}></img>
          
          <div style={{display:'flex', flexDirection:'column'}}>
            <p className='label'>Order Ref</p>
            <p className='text'>{orderRef}</p>
          </div>
        </div>
        <NameBox name={customerName} heading="Customer Name" />
      </div>
      <div className='d-flex flex-column flex-sm-row gap-5'>
        <PriceBox topText={"Order Value"} bottomText={`\u00A3${orderValue}`} />
        <PriceBox topText={"Order Date"} bottomText={orderDate} />
      </div>
      
        {isService && !merchantRecievedService ? (
          <div className="d-flex flex-column flex-sm-row">
          <IconBox className={"icon-box no-left-border"} icon={viewIcon} subtitle="View" onClick={viewOnClick} />
          <IconBox
          icon={tracIcon}
          subtitle="Track"
          onClick={() => {
            window.open(
              `https://www.fedex.com/fedextrack/?tracknumbers=${ordetTrackingID}`,
              "_blank"
            );
          }}
        />
        </div>
        ):(
          <div className="d-flex flex-column flex-sm-row">
          <IconBox className={"icon-box no-left-border"} icon={viewIcon} subtitle="View" onClick={viewOnClick} />
          <IconBox
            icon={!shippingLabel || isService ? printIconDark : printIconLight}
            subtitle="Print label"
            disabled={!shippingLabel || isService ? false : true}
            onClick={!shippingLabel || isService ? printOnClick : null}
            className={!shippingLabel || isService? "icon-box" : "borderLeftDisabled"}
          />
          <button disabled={!shippingLabel ? true : false} className={shippingLabel ? "icon-box" : "borderLeftDisabled"} onClick={onReadyForShipment}>
            {shippingLabel  ? <RequestFedExIcon /> : <RequestFedExIcon fill="gray" />}
            <Title text={"Request FedEx"} className="subtitle text-nowrap" />
          </button> 
          </div>
        )}
        
    </div>
   
  );
};
